import SalePlanHomeDiagram from "../../components/statistics/planHomeDiagram";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "sonner";
import PanelSearch from "../../components/filters/panelSearch";
import { FilterIcon } from "../../icons/filter";
import UserListTable from "../../components/users/userListTable";
import { actions, RootState } from "../../state/reducer";
import { closeModal, openModal } from "../../state/modalSlice";
import UserFilterModal from "../../modals/filters/user";
import { UserFilters } from "../../forms/filters/user";
import { UserShortInfo } from "types";
import PanelPage from "../../components/panel/panelPage";
import SalePlanNoCalcDiagram from "../../components/statistics/planDiagreamNoCalc";
import { getMonthAndYear } from "../../utils";
import GroupListTableWithSales from "../../components/users/groupListTableWithSales";
import { GroupSalesArrayData, statsBackend } from "../../services";

const SalesGroupPlanPage = () => {
  const [searchValue, setSearchValue] = useState("");
  const State = useSelector((state: RootState) => state);
  const [totalValues, setTotalValuse] = useState<{
    plan: number;
    fact: number;
  }>({
    plan: 0,
    fact: 0
  });
  const [salesData, setSalesData] = useState<GroupSalesArrayData[]>([])
  const dispatch = useDispatch();

  // Заполняем данные по всем группам и по каждой
  useEffect(() => {
     statsBackend.getAllGroupsSalePlan().then((res) => {
        setSalesData(res.values || [])
     }).catch((e) => {
       console.log("Error:", e)
     });
     statsBackend.getTotalGroupsSalePlan().then((res) => {
      if (res.value)
      setTotalValuse({
        plan: res.value.total_plan,
        fact: res.value.total_actual
      })
   }).catch((e) => {
     console.log("Error:", e)
   });
  }, [State.selectedItem])


  const search = (value: string) => {
    setSearchValue(value);
  };

  const handleOpenFilters = () => {
    dispatch(
      openModal({
        component: UserFilterModal,
        context: {
          onApplyFilters: (filters: UserFilters) => {
            setSearchValue("");
            dispatch(actions.userRequestParams(filters));
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  const { month, year } = getMonthAndYear(new Date())

  return (
    <PanelPage>
                <div className="panelColumnFull">
          <div className="flex between w100 panelColumnFull">
            <div className="columnCenter panelColumnFull">
              {totalValues.plan > 0 && <SalePlanNoCalcDiagram 
              enableSettings={true} 
              month={month} 
              year={year} 
              fact={totalValues.fact} 
              plan={totalValues.plan} 
              title={"План продаж (все группы)"} 
               />}
              <div className="panel eventListPanel">
                <div className="flex between panelSearchContainer">
                  <PanelSearch hint={"Поиск по ФИО"} onChange={search} />
                  <div className="btn filterBtn" onClick={handleOpenFilters}>
                    <FilterIcon width={20} height={20} />
                  </div>
                </div>
                <GroupListTableWithSales search={searchValue} sales={salesData} />
              </div>
            </div>
          </div>
        </div>
      </PanelPage>
  );
};

export default SalesGroupPlanPage;
